import React, { useState, useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./ThreeImageList.module.css";
import { encoded } from "@/utils";
import { CoupangAdBanner, FrameType } from "@/components";

const ThreeImageList = React.memo(function ({
  list = [{ id: "", image: "", title: "", caption: "" }],
  defaultUrl = "",
  updateUrl = "",
  isUpdate = false,
  isDelete = false,
  isReset = false,
  setDeletes = () => {},
  resetDeletes = () => {},
  headerTitle = "",
}) {
  const adMessage =
    "이 포스팅은 쿠팡 파트너스 활동의 일환으로, 이에 따른 일정액의 수수료를 제공받습니다.";
  const [width, setWidth] = useState(window.innerWidth);
  const defaultState = {
    onLoad: false,
    listByThrees: [],
  };
  const [state, setState] = useState({
    ...defaultState,
  });

  const resetState = () => {
    setState({ ...defaultState });
  };
  const addOnLoadClass = () => {
    setState((s) => ({ ...s, onLoad: true }));
  };
  const makeListByThrees = () => {
    setState((s) => ({ ...s, listByThrees: list }));
  };
  const adKey = useMemo(() => new Date().getTime(), []);
  const handleResize = () => {
    setWidth(window.innerWidth);
  };
  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  useEffect(() => {
    if (isReset) {
      resetState();
    }
    makeListByThrees();
    const callbackId = requestIdleCallback(addOnLoadClass);
    return () => {
      resetState();
      cancelIdleCallback(callbackId);
    };
  }, [isReset, isUpdate, list]);
  return (
    <div
      className={
        state.onLoad
          ? `${styles.releaseListArea} ${styles.loaded}`
          : styles.releaseListArea
      }
    >
      <div
        className={
          state.listByThrees.length > 2
            ? styles.releaseList
            : `${styles.releaseList} ${styles.releaseListAlign}`
        }
      >
        {state.listByThrees.length === 0 ? null : (
          <>
            {state.listByThrees.map((content, idx) => (
              <Content
                key={idx}
                id={content.id}
                mediaId={content.mediaId}
                image={content.image}
                title={content.title}
                defaultUrl={defaultUrl}
                updateUrl={updateUrl}
                isUpdate={isUpdate}
                isDelete={isDelete}
                isReset={isReset}
                setDeletes={setDeletes}
                resetDeletes={resetDeletes}
                instaRegDate={content.instaRegDate}
                reelsCategoryId={content.reelsCategoryID}
                headerTitle={headerTitle}
              />
            ))}
          </>
        )}
        <div className={styles.release}>
          <div className={styles.releaseArea}>
            <div className={`${styles.releaseImage} ${styles.adImageCustom}`}>
              <CoupangAdBanner key={adKey} frameType={FrameType.RECTANGLE} />
            </div>
            <div className={styles.title2}>
              <span className={styles.adMessage}>{adMessage}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

export default ThreeImageList;

const Content = React.memo(
  ({
    id = "",
    mediaId = "",
    image = "",
    title = "",
    instaRegDate = "",
    defaultUrl = "",
    updateUrl = "",
    isUpdate = false,
    isDelete = false,
    isReset = false,
    setDeletes = () => {},
    resetDeletes = () => {},
    reelsCategoryId = "",
    headerTitle = "",
  }) => {
    const navigate = useNavigate();
    const defaultState = {
      onOff: false,
    };
    const [state, setState] = useState({
      ...defaultState,
    });

    const resetState = () => {
      setState({ ...defaultState });
    };
    const click = () => {
      const encodedTitle = encoded(title);
      if (!isUpdate && !isDelete) {
        const info = encoded(
          {
            id: id,
            mediaId: mediaId,
            reelsNm: title,
          },
          true
        );
        navigate(`${defaultUrl}/${info}`);
        return;
      }
      if (isUpdate) {
        const randomTag = new Date().getTime();
        const info = encoded(
          {
            id: id,
            mediaId: mediaId,
            reelsNm: title,
            instaRegDate: instaRegDate,
            image: image,
            reelsCategoryId: reelsCategoryId,
            title: headerTitle,
          },
          true
        );
        navigate(`${updateUrl}/${randomTag}/${info}`);
        return;
      }
      if (isDelete) {
        setState((s) => ({ ...s, onOff: !s.onOff }));
        return;
      }
    };
    const imageStyle = {
      backgroundImage: `url(${image})`,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
    };

    useEffect(() => {
      if (isReset) {
        resetState();
      }
      return () => {
        resetState();
      };
    }, [isReset]);
    useEffect(() => {
      if (isDelete && state.onOff) {
        setDeletes({ index: id });
      } else if (isDelete && !state.onOff) {
        resetDeletes({ index: id });
      }
    }, [isDelete, state.onOff]);
    return (
      <div className={styles.release} onClick={click}>
        <div className={styles.releaseArea}>
          <div className={styles.releaseImage} style={imageStyle} />
          <div className={styles.title2}>
            <span className={styles.bestPizzaNyc}>{title}</span>
          </div>
          {isDelete && state.onOff && (
            <div className={styles.listItem}>
              <div className={styles.checkOne} />
            </div>
          )}
        </div>
      </div>
    );
  }
);
